import styled from "styled-components"
import { COLOR } from "styles/style-constants"

const RedText = styled.span`
  color: ${COLOR.softRed};
  ${(props) => props.disabled && `color: ${COLOR.lineGray}`};
`

export default RedText
